export default __webpack_public_path__ + "static/media/logogenesis.503f475e.jpeg";